/**
 * "Is an app modal open?" — DOM check used at auto-start / hint time.
 * Covers the shared .modal-overlay family (What's New, Feedback, student
 * details), dialogs, and the idle warning (role="alertdialog"). The chrome
 * modal state (feedback / what's new / profile / idle / MFA) also arrives as
 * a prop so the provider re-checks when they close.
 */
export const APP_MODAL_SELECTOR = '.modal-overlay, [role="dialog"], [role="alertdialog"], [data-app-modal]';

export function isAppModalOpen(root = typeof document !== 'undefined' ? document : null) {
  if (!root) return false;
  return !!root.querySelector(APP_MODAL_SELECTOR);
}
